<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <animateTransform
        v-if="animate"
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        from="0 12 13"
        to="360 12 13"
        dur="3s"
        repeatCount="indefinite"
        calcMode="discrete"
        values="0 12 13; 60 12 13; 120 12 13; 180 12 13; 240 12 13; 300 12 13" />
      <ellipse cx="11.9999" cy="3.54545" rx="3.53698" ry="3.54545" :fill="colors.primary" />
      <ellipse cx="11.9999" cy="22.4546" rx="3.53698" ry="3.54545" :fill="colors.primary" />
      <ellipse cx="11.9999" cy="12.9999" rx="3.53698" ry="3.54545" :fill="colors.secondary" />
      <ellipse cx="20.1684" cy="17.7273" rx="3.54334" ry="3.5391" :fill="colors.primary" />
      <ellipse cx="3.83147" cy="8.2727" rx="3.54334" ry="3.5391" :fill="colors.primary" />
      <ellipse cx="3.83174" cy="17.7274" rx="3.54334" ry="3.5391" :fill="colors.secondary" />
      <ellipse cx="20.1687" cy="8.27267" rx="3.54334" ry="3.5391" :fill="colors.secondary" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    darkMode: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colors() {
      return {
        primary: this.darkMode ? "#A2E0F8" : "#07455D",
        secondary: this.darkMode ? "#2DA7D7" : "#0D8ABA"
      }
    }
  }
}
</script>
